import { render } from "./Users.vue?vue&type=template&id=3803e81e"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
script.render = render

export default script